import gql from 'graphql-tag';

export default gql`
  fragment mailSendActivityFragment on MailSendActivity {
    title
    body
    campaign {
      name
    }
    contentMailFormVersion {
      id
      uuid
      version
      mailForm {
        content {
          uuid
          title
        }
      }
    }
  }
`;
